import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch
} from "react-router-dom";
import AlertModal from "../shared/modals/AlertModal";
import { SpinnerComponent as Spinner } from '../shared/spinner/spinnerComponent'
import { ProtectedRoute, PublicRoute } from "../routes/customRoutes";
import routes from "./index";
import { Redirect } from "react-router";
import ROUTES from "../shared/constants/routes";
import { getData } from "../shared/utils/storage.util";

const RouteComponent = () => {

  useEffect(() => {})
  
  // Prepare Route
  const getRoutes = (route, i) => {
    const { isPrivateRoute, ...restRoute } = route;   
    if (route.isPrivateRoute) {
      return <ProtectedRoute key={i} {...restRoute} />
    } else {
      return <PublicRoute key={i} {...restRoute} />
    }
  };

  // Default Route
  const defaultRoute = () => {
    let route = getData('isLogin')==='true' ? ROUTES.DASHBOARD : ROUTES.LANDING;
    return <Redirect to={route} />
  }

  return (
    <Router>
      <AlertModal />
      <Spinner name='Oval' />
      <div className="customContainer">
        <Switch>
          {/*iterating routes */}
          {routes.map((route, i) => (
            getRoutes(route, i)
          ))}
          {defaultRoute()}
        </Switch>
      </div>
    </Router>
  );
}

export default RouteComponent;